import React from 'react';
import { Alert, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useTypedProjectCostContext } from './useTypedProjectCostContext';
import { formatCurrencyFromCents, formatHours } from './utils';
import type { SavedCostAnalysis } from './types';

const ProjectsCostHistoryPage: React.FC = () => {
  const {
    analysisHistory,
    setAnalysisHistory,
    applyHistoryFilters,
    removeHistoryItem,
  } = useTypedProjectCostContext<{
    analysisHistory: SavedCostAnalysis[];
    setAnalysisHistory: React.Dispatch<React.SetStateAction<SavedCostAnalysis[]>>;
    applyHistoryFilters: (item: SavedCostAnalysis) => void;
    removeHistoryItem: (historyId: string) => void;
  }>();

  return (
    <Card className="mb-3">
      <Card.Header>Histórico recente de análises (local)</Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <small className="text-muted">
            Cada cálculo fica salvo localmente para comparação rápida e reaplicação de filtros.
          </small>
          {analysisHistory.length > 0 && (
            <Button size="sm" variant="outline-danger" onClick={() => setAnalysisHistory([])}>
              Limpar histórico
            </Button>
          )}
        </div>
        {analysisHistory.length === 0 ? (
          <Alert variant="light" className="mb-0">
            Ainda não há execuções salvas. Rode um cálculo em{' '}
            <Link to="/projects/costs/analise">Análise</Link>.
          </Alert>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm table-bordered table-hover mb-0">
              <thead>
                <tr>
                  <th>Executado em</th>
                  <th>Período</th>
                  <th>Issues</th>
                  <th>Custo</th>
                  <th>Receita</th>
                  <th>Margem</th>
                  <th>Horas sem mapeamento</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {analysisHistory.map((item) => (
                  <tr key={item.id}>
                    <td>{new Date(item.createdAt).toLocaleString('pt-BR')}</td>
                    <td>{item.worklogStartDate || 'início livre'} até {item.worklogEndDate || 'fim livre'}</td>
                    <td>{item.issuesCount}</td>
                    <td>{formatCurrencyFromCents(item.totalCostCents)}</td>
                    <td>{formatCurrencyFromCents(item.totalRevenueCents)}</td>
                    <td>{formatCurrencyFromCents(item.totalMarginCents)}</td>
                    <td>{formatHours(item.unmatchedHours)} h</td>
                    <td>
                      <div className="d-flex gap-1">
                        <Button size="sm" variant="outline-primary" onClick={() => applyHistoryFilters(item)}>
                          Reaplicar filtros
                        </Button>
                        <Button size="sm" variant="outline-danger" onClick={() => removeHistoryItem(item.id)}>
                          Remover
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ProjectsCostHistoryPage;
